<template>
  <div>
    <h1 class="text-h3 text-sm-h2 text-md-h1 font-weight-bold">
      Talk to the Duck.
    </h1>
    <p class="text-h5 text-sm-h4 text-white mt-6 mt-sm-10">
      Say it. Solve it. 
    </p>
    <v-btn
      class="mt-6"
      color="primary"
      href="#careers"
      size="large"
      min-height="48"
    >
      Talk to Us
    </v-btn>
  </div>
</template>

<style scoped>
</style>